import React from 'react';
import { Button, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
export default function FilterButtons({ disabled, name, onClick }) {
  const theme = useTheme();
  const handleChange = (value) => {
    onClick(value);
  };
  const {t} = useTranslation()
  const { i18n: {language} } = useTranslation();
  return (
    <Button
      style={{
        backgroundColor: name === 'Reset' ? theme.palette.primary.light : theme.palette.primary.main,
        borderRadius: '10px',
        width: language === 'en' ?  '45px' : '65px',
        height: '19px',
        color: '#FFFFFF',
        textTransform: 'capitalize',
        minWidth: '50px',
      }}
      disabled={disabled}
      className="ff-Roboto fs-10 fw-medium "
      onClick={(value) => {
        handleChange(name);
      }}
    >
      {t(name)}
    </Button>
  );
}
